// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-TravelerDetails-styles___paper--YB3d8 {
  padding: 32px;
  max-width: 900px;
  margin: 0 auto 30px;
  margin-left: 0;
}

.components-TravelerDetails-styles___paperAccount--Bu2i2 {
  padding: 32px;
  max-width: 736px;
  margin: 0 auto 0 0;
  width: 100%;
  padding-left: 22px;
  padding-right: 22px;
}

.components-TravelerDetails-styles___paperAccountLoading--aGFAG {
  padding: 32px;
  max-width: 736px;
  margin: 0 auto 0 0;
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.components-TravelerDetails-styles___dropdown--UV0_Q {
  padding: 15px;
  max-width: 736px;
}

.components-TravelerDetails-styles___root--iOl9o {
  width: 100%;
}

.components-TravelerDetails-styles___menuItem--rbSzl {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-TravelerDetails-styles___listItem--q06ZW {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.components-TravelerDetails-styles___location--rnkIH {
  margin-bottom: 5px;
}

.components-TravelerDetails-styles___inputContainer--gGQWb {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___passportInfo--ULSLg {
    padding-bottom: 24px;
  }

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___inputContainerTravelerSelection--IISEP {
    padding: 16px 0 0;
    border-bottom: none;
    padding-top: 0;
  }

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___inputContainerTravelerSelectionOpen--Bmq59 {
    padding: 0 0 32px 0;
  }

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___wrapperContainer--_LS6p {
    border-top: 1px solid #dddee0;
    flex-direction: column;
    padding-top: 32px;
  }

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___wrapperContainer--_LS6p .components-TravelerDetails-styles___subtitle--iniOk {
      color: #6d717a;
      font-size: 15px;
      padding: 6px 0 16px;
    }

.components-TravelerDetails-styles___inputContainer--gGQWb.components-TravelerDetails-styles___wrapperContainer--_LS6p .components-TravelerDetails-styles___radioGroupLabel--XaceB {
      font-weight: 400;
    }

.components-TravelerDetails-styles___secondarySelectInput--BJ5sY {
  display: flex;
  align-items: center;
}

.components-TravelerDetails-styles___inputWrapper--BHow2 {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-TravelerDetails-styles___inputInVisible--g4qhl {
  display: none;
}

.components-TravelerDetails-styles___inputWrapper_department--WDakw {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-TravelerDetails-styles___inputWrapper_department--WDakw div label {
    z-index: 0;
  }

.components-TravelerDetails-styles___table--iCPzv {
  margin: 20px 0 0;
}

.components-TravelerDetails-styles___tableHead--HRwxl {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-TravelerDetails-styles___tableRow--GO10g {
  height: 68px !important;
}

.components-TravelerDetails-styles___tableRow--GO10g:last-child .components-TravelerDetails-styles___tableCell--ju6P3 {
      border: none;
    }

.components-TravelerDetails-styles___tableRow--GO10g.components-TravelerDetails-styles___addNewTableRow--MNUIM {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-TravelerDetails-styles___tableRow--GO10g td:first-child {
    padding-left: 0 !important;
  }

.components-TravelerDetails-styles___tableRow--GO10g.components-TravelerDetails-styles___paymentTableRow--SKggx:last-child .components-TravelerDetails-styles___tableCell--ju6P3 {
        border-bottom: 1px solid rgba(224, 224, 224, 1);
      }

.components-TravelerDetails-styles___tableCell--ju6P3 {
  font-size: 15px !important;
  padding: 16px 15px 16px 15px !important;
  min-width: unset !important;
}

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 button {
      padding-left: 0;
      padding-right: 0;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 .components-TravelerDetails-styles___button_more--_U7FU {
      min-width: 10px;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 .components-TravelerDetails-styles___button_more--_U7FU:hover {
      background-color: transparent !important;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 .components-TravelerDetails-styles___menuList--R_Dcw {
      font-size: 15px;
      letter-spacing: 0;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 .components-TravelerDetails-styles___menuList--R_Dcw li:nth-child(3) {
        font-size: 15px;
        color: #fc3b60 !important;
        font-weight: 600;
      }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___removeCell--LzP71 .components-TravelerDetails-styles___menuList--R_Dcw svg {
        margin-right: 5px;
      }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___inputTableCell--I7fIl {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___inputTableCell--I7fIl > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___buttonTableCell--SpQMv {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-TravelerDetails-styles___tableCell--ju6P3 .components-TravelerDetails-styles___alertMessageCont--mYpSr {
    display: flex;
    flex-direction: column;
  }

.components-TravelerDetails-styles___tableCell--ju6P3 .components-TravelerDetails-styles___alertMessageCont--mYpSr .components-TravelerDetails-styles___alertMessage--P6W61 {
      font-family: 'Roboto-Regular', 'Roboto';
      font-size: 11px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-top: 4px;
      font-weight: 400;
    }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___tableCellPayment--w6Mu7 {
    color: #6d717a;
  }

.components-TravelerDetails-styles___tableCell--ju6P3.components-TravelerDetails-styles___tableCellType--AEYIJ {
    font-weight: 600;
    color: #1b2432;
  }

.components-TravelerDetails-styles___tableCell--ju6P3 .components-TravelerDetails-styles___alertMessageContInside--pIiMU {
    display: flex;
    flex-direction: row;
    margin-top: 17px;
  }

.components-TravelerDetails-styles___tableCell--ju6P3 .components-TravelerDetails-styles___alertMessageContInside--pIiMU svg {
      margin-right: 5px !important;
    }

.components-TravelerDetails-styles___extraMargin--BbW24 {
  padding-left: 36px !important;
}

.components-TravelerDetails-styles___alertIcon--jpv4l {
  width: 16px !important;
  padding-right: 0 !important;
  min-width: 16px !important;
}

.components-TravelerDetails-styles___emptyData--dlG9h {
  padding: 24px 0;
}

.components-TravelerDetails-styles___selectWrapper--TZVDi {
  width: 100%;
}

.components-TravelerDetails-styles___phoneFields--P3u4k {
  display: flex;
}

.components-TravelerDetails-styles___phoneFields--P3u4k .components-TravelerDetails-styles___countryCode--Fdjfa {
    margin-right: 6px;
    max-width: 192px;
  }

.components-TravelerDetails-styles___buttons--KzdUu {
  border-top: 1px solid #dddee0;
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
}

.components-TravelerDetails-styles___buttonDeactivateCont--e8W1O {
  padding-top: 32px;
  display: flex;
  justify-content: flex-start;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}

.components-TravelerDetails-styles___buttonDeactivate--ntVGz {
  border: 1px solid #fc3b60 !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 161px !important;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}

.components-TravelerDetails-styles___buttonReactivate--BoTtP {
  border: 1px solid #318afb !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 161px !important;
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
}

.components-TravelerDetails-styles___cancel--tgzXk {
  color: #6d717a;
  margin-right: 12px;
}

.components-TravelerDetails-styles___tabs--VyIQ6,
.components-TravelerDetails-styles___tabbs--OAbTJ,
.components-TravelerDetails-styles___tab--kEhXd,
.components-TravelerDetails-styles___tabb--ppwu8 {
  text-transform: initial !important;
}

.components-TravelerDetails-styles___tabs--VyIQ6 {
  border-bottom: 1px solid #c6c8cc;
}

.components-TravelerDetails-styles___tabb--ppwu8 {
  border-bottom: 1px solid #c6c8cc !important;
  padding: 15px;
}

.components-TravelerDetails-styles___loyalityTabs--VXZzj {
  margin-top: 16px;
}

.components-TravelerDetails-styles___loyalityTabs--VXZzj .components-TravelerDetails-styles___tab--kEhXd {
    flex: 1;
    max-width: 170px;
  }

.components-TravelerDetails-styles___addProgram--CBaJ2 {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  padding: 18px 0 18px 0;
  cursor: pointer;
}

.components-TravelerDetails-styles___addProgram--CBaJ2:hover {
    color: #f6f6f7;
  }

.components-TravelerDetails-styles___addProgram--CBaJ2 {
  width: 100%;
  font-weight: 500;
}

.components-TravelerDetails-styles___addIcon--vxsDN {
  height: 18px;
  margin-right: 5px;
}

.components-TravelerDetails-styles___close--C2E3k {
  cursor: pointer;
  display: none;
}

.components-TravelerDetails-styles___close--C2E3k .components-TravelerDetails-styles___icon--iyYSg {
    color: rgba(0, 0, 0, 0.23);
    font-size: 16px;
    margin-right: 2px;
  }

.components-TravelerDetails-styles___loaderContainer--xQvgA {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-TravelerDetails-styles___sortBy--Ri3ZK {
  position: absolute;
  right: 0;
  font-size: 15px;
  height: 48px;
  padding: 0 15px;
}

.components-TravelerDetails-styles___sortBy--Ri3ZK .components-TravelerDetails-styles___select--ujRkv {
    margin-left: 5px;
    font-weight: 700;
    font-size: 15px;
    height: 48px !important;
    min-height: 48px !important;
  }

.components-TravelerDetails-styles___sortBy--Ri3ZK .components-TravelerDetails-styles___select--ujRkv:before,
    .components-TravelerDetails-styles___sortBy--Ri3ZK .components-TravelerDetails-styles___select--ujRkv:after {
      transition: none;
      border-bottom-color: transparent !important;
    }

.components-TravelerDetails-styles___sortBy--Ri3ZK .components-TravelerDetails-styles___select--ujRkv > div {
      display: flex;
      align-items: center;
    }

.components-TravelerDetails-styles___sortBy--Ri3ZK .components-TravelerDetails-styles___select--ujRkv .components-TravelerDetails-styles___icon--iyYSg {
      width: 20px;
      height: 20px;
      margin-left: -24px;
      margin-top: -3px;
      pointer-events: none;
    }

.components-TravelerDetails-styles___selected--UkJCB {
  min-height: 52px;
  height: auto !important;
}

.components-TravelerDetails-styles___selected--UkJCB div .components-TravelerDetails-styles___iconStyle--nuYJf {
      transform: rotate(180deg);
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
      margin-right: 0;
    }

.components-TravelerDetails-styles___select--ujRkv {
  min-height: 52px;
  height: auto !important;
}

.components-TravelerDetails-styles___select--ujRkv div .components-TravelerDetails-styles___iconStyle--nuYJf {
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
      margin-right: 0;
    }

.components-TravelerDetails-styles___informationTitle--YNijO {
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  font-family: 'Roboto-Medium', 'Roboto', sans-serif;
}

.components-TravelerDetails-styles___addMarginTop--SH3HM {
  margin-top: 32px;
}

.components-TravelerDetails-styles___billingAddress--_L0aG {
  font-size: 15px;
  color: #318afb;
  letter-spacing: 0;
  text-align: right;
}

.components-TravelerDetails-styles___billingAddressContainer--uBbq7 {
  display: flex;
  justify-content: space-between;
}

.components-TravelerDetails-styles___rule--CpREB {
  margin-top: 30px;
}

.components-TravelerDetails-styles___fraudRules--MF5Ma {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-direction: column;
}

@media only screen and (min-width: 1220px) {

.components-TravelerDetails-styles___fraudRules--MF5Ma {
    flex-direction: row
}
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraud--atVjN {
    margin-top: 10px;
    width: 100%;
    margin-right: 0;
  }

@media only screen and (min-width: 1220px) {

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraud--atVjN {
      margin-right: 10px
  }
    }

@media only screen and (min-width: 1300px) {

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraud--atVjN {
      width: 270px;
      max-width: 270px
  }
    }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraud--atVjN {

    font-family: 'Roboto-Regular', 'Roboto';
    font-weight: 500;
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
}

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraud--atVjN .components-TravelerDetails-styles___description--ga9FB {
      font-family: 'Roboto-Regular', 'Roboto';
      font-weight: 400;
      font-size: 13px;
      color: #1b2432;
      letter-spacing: 0;
      margin-top: 6px;
    }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraudSelect--ufQz1 {
    width: 100%;
  }

@media only screen and (min-width: 1220px) {

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraudSelect--ufQz1 {
      max-width: 300px
  }
    }

@media only screen and (min-width: 1420px) {

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___fraudSelect--ufQz1 {
      width: 320px;
      max-width: 320px
  }
    }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___inputWrapper--BHow2 div {
      min-width: 220px;
    }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___inputWrapper--BHow2 .components-TravelerDetails-styles___marginNormal--MRC8y {
      width: 220px;
    }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___recommended--iOZGn {
    background: rgba(18, 218, 159, 0.1);
    border: 1px solid #12da9f;
    border-radius: 4px;
    width: 105px !important;
    height: 24px;
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___recommendedItemContainer--X7lxR {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___tableCell--ju6P3:first-child {
    padding-left: 0 !important;
    padding-right: 63px !important;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___selectWrapper--TZVDi {
    margin-top: 0 !important;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___editAnalyticsContainer--bWRTC {
    display: flex;
    justify-content: space-between;
    width: 320px;
    max-width: 320px;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___editAnalyticsContainer--bWRTC svg {
    margin-right: 15px;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___editAnalyticsText--OpSGR {
    font-weight: 700;
  }

.components-TravelerDetails-styles___fraudRules--MF5Ma .components-TravelerDetails-styles___editAnalytics--MaBT2 {
    cursor: pointer;
    font-size: 15px;
    color: #318afb;
    letter-spacing: 0;
    text-align: right;
  }

.components-TravelerDetails-styles___header--epoL8 {
  display: flex;
}

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___title--sc9Cy {
    flex: 1;
    font-size: 21px;
    line-height: 24px;
    font-weight: 500;
  }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___title--sc9Cy span {
      font-size: 15px;
      color: #6d717a;
      font-weight: 400;
    }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___tripAdvisor--lhkrD {
    text-align: right;
  }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___tripAdvisor--lhkrD img {
      width: 95px;
      height: auto;
    }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 {
    display: flex;
    align-items: self-end;
  }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 .components-TravelerDetails-styles___avatarContainer--maUSH {
      margin-right: 24px;
      margin-top: 4px;
    }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 .components-TravelerDetails-styles___avatarContainer--maUSH .components-TravelerDetails-styles___avatar--hwZ5k {
        width: 32px;
        height: 32px;
      }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 .components-TravelerDetails-styles___avatarContainer--maUSH .components-TravelerDetails-styles___avatarLetter--SS64K {
        width: 32px;
        height: 32px;
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
        text-align: center;
        background-color: #e0e2e6;
        text-transform: uppercase;
      }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 .components-TravelerDetails-styles___titleStyle--Q070x {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 21px;
      color: #1b2432;
      letter-spacing: 0;
      margin-bottom: 7px;
    }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___avatarAndName--ueu81 .components-TravelerDetails-styles___subtitleStyle--yQV43 {
      font-family: 'Roboto';
      font-weight: 400;
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
    }

.components-TravelerDetails-styles___header--epoL8 .components-TravelerDetails-styles___passengerInfo--d0VCq {
    display: flex;
    align-content: space-between;
    justify-content: space-between;
    max-width: 672px;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw {
  padding: 32px 0;
  border-bottom: 1px solid #c6c8cc;
}

.components-TravelerDetails-styles___userDetailsHeader--i3ddw:last-child {
    padding: 32px 0 0;
    border-bottom: none;
    padding-top: 20px;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___title--sc9Cy {
    margin-bottom: 24px;
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 500;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userName--d4zNt {
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 500;
    font-family: 'Roboto';
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userDetailsInfo--Agwab {
    max-width: 850px;
    border: 1px solid #dddee0;
    padding: 23px;
    border-radius: 4px;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___Info--mLi4F {
    display: flex;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY {
    min-width: 280px;
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
    line-height: 20px;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY .components-TravelerDetails-styles___passportInfo--ULSLg {
      display: flex;
    }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY .components-TravelerDetails-styles___passportInfo--ULSLg p {
        margin-top: 0px;
      }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY .components-TravelerDetails-styles___passportInfo--ULSLg p:first-child {
        margin-top: 13px;
      }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY .components-TravelerDetails-styles___passportInfo--ULSLg .components-TravelerDetails-styles___passList--KS1AD {
        line-height: 7px;
        margin-top: 6px;
        margin-left: 5px;
        color: #1b2432;
      }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY span {
      color: #1b2432;
      letter-spacing: 0;
    }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRow--nW6cY .components-TravelerDetails-styles___label--oIbRZ {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
      line-height: 20px;
    }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRowWithIcon--iPtyz {
    display: flex;
    align-items: center;
  }

.components-TravelerDetails-styles___userDetailsHeader--i3ddw .components-TravelerDetails-styles___userInfoRowWithIcon--iPtyz svg {
      margin-right: 10px;
    }

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd {
  display: flex;
  align-items: stretch;
}

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd .components-TravelerDetails-styles___iconContainer--QA7uP {
    margin-right: 24px;
    margin-top: 4px;
  }

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd .components-TravelerDetails-styles___iconContainer--QA7uP .components-TravelerDetails-styles___icon--iyYSg {
      width: 32px;
      height: 32px;
    }

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd .components-TravelerDetails-styles___infoContainer--ndcXT {
    min-width: 0;
    flex: 1;
  }

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd .components-TravelerDetails-styles___titleStyle--Q070x {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 21px;
    color: #1b2432;
    letter-spacing: 0;
    margin-bottom: 7px;
  }

.components-TravelerDetails-styles___iconAndInfoContainer--wZbQd .components-TravelerDetails-styles___subtitleStyle--yQV43 {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
  }

.components-TravelerDetails-styles___buttonContainer--dtFoz {
  display: flex;
  justify-content: flex-end;
}

.components-TravelerDetails-styles___userNameAndActionbuttonContaner--kilSl {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-TravelerDetails-styles___noBorder--y2318 fieldset {
    border: none !important;
  }

.components-TravelerDetails-styles___noBorder--y2318 {
  margin: 0 !important;
}

.components-TravelerDetails-styles___noBorder--y2318 div {
    padding: 0 !important;
    padding-left: 1px !important;
    font-size: 17px;
    font-weight: 600;
  }

.components-TravelerDetails-styles___line--TtFFZ {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.components-TravelerDetails-styles___selectTraveler--OfgJ5 {
  min-width: 118px;
  font-size: 17px;
}

.components-TravelerDetails-styles___avatarAndNameActionButton--oipRU {
  display: flex;
  justify-content: space-between;
  flex: 1;
}

.components-TravelerDetails-styles___membershipDescription--RlzKC {
  margin-top: 20px;
  font-family: 'Roboto';
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-TravelerDetails-styles___popupButtonsContainer--iSrXY {
  border-top: 1px solid #e0e2e6;
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.components-TravelerDetails-styles___popupButtonsContainer--iSrXY button {
    width: 150px;
    height: 52px;
    font-size: 17px;
  }

.components-TravelerDetails-styles___popupButtonsContainer--iSrXY button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-TravelerDetails-styles___popupButtonsContainer--iSrXY .components-TravelerDetails-styles___cancelButton--hnmYV {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-TravelerDetails-styles___addNewTableRowProgram--D3V2x {
  margin-top: 20px;
}

.components-TravelerDetails-styles___profileInfo--I5XzE {
  display: flex;
  justify-content: flex-start;
}

.components-TravelerDetails-styles___profileInfo--I5XzE p {
    margin-top: 6px;
    margin-bottom: 6px;
  }

.components-TravelerDetails-styles___profileInfo--I5XzE .components-TravelerDetails-styles___passportInfo--ULSLg p {
      margin-top: 6px !important;
      margin-bottom: 6px;
    }

.components-TravelerDetails-styles___passportInfoLabel--FU1N1 {
  margin-top: 6px !important;
}

.components-TravelerDetails-styles___selected--UkJCB {
  min-height: 52px;
  height: auto !important;
}

.components-TravelerDetails-styles___selected--UkJCB div .components-TravelerDetails-styles___iconStyleProfile--JuOuW {
      transform: rotate(180deg);
      top: calc(50% - 8px);
      right: -20px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
      margin-right: 0;
    }

.components-TravelerDetails-styles___select--ujRkv {
  min-height: 52px;
  height: auto !important;
}

.components-TravelerDetails-styles___select--ujRkv div .components-TravelerDetails-styles___iconStyleProfile--JuOuW {
      top: calc(50% - 8px);
      right: -20px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
      margin-right: 0;
    }

.components-TravelerDetails-styles___addProgramButtonLabel--Km8fT {
  font-family: 'Roboto';
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  font-weight: 600;
}

.components-TravelerDetails-styles___loyaltyProgramTable--G9v4X td {
    font-family: 'Roboto';
  }

.components-TravelerDetails-styles___loyaltyProgramTable--G9v4X td:first-child {
    font-weight: 600;
  }

.components-TravelerDetails-styles___editButton--Hbc6a {
  width: 55px !important;
  min-width: 55px !important;
}

.components-TravelerDetails-styles___editButton--Hbc6a:hover {
    background-color: #318afb !important;
    color: #ffffff;
  }

.components-TravelerDetails-styles___loyalityTabs--VXZzj {
  border-bottom: none !important;
}

.components-TravelerDetails-styles___loyalityTabs--VXZzj button {
    border-bottom: 1px solid #c6c8cc !important;
  }

.components-TravelerDetails-styles___passengerDesc--fttXu {
  color: #1b2432;
}

.components-TravelerDetails-styles___balance--znijq {
  width: 354px;
  margin-right: 0;
  margin-left: 30px !important;
}

.components-TravelerDetails-styles___userIdPaper--lU1A3 {
  width: 354px;
  margin-right: 0;
  margin-top: 30px;
  margin-left: 30px !important;
}

.components-TravelerDetails-styles___AccountBalance--bkEeF {
  display: flex;
}

.components-TravelerDetails-styles___points--lop85 {
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 21px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-TravelerDetails-styles___rewardIconAndText--Qhmsm {
  margin-top: 22px;
  display: flex;
}

.components-TravelerDetails-styles___rewardIconAndText--Qhmsm svg {
    margin-right: 18px;
  }

.components-TravelerDetails-styles___loyaltyProgramTable--G9v4X {
  border-bottom: 1px solid rgba(224, 224, 224, 1);
}

.components-TravelerDetails-styles___accountDetailsContiner--UE6FS {
  display: flex;
  flex-direction: row;
}

.components-TravelerDetails-styles___firstToLeft--S1ndV td:first-child {
    padding-left: 0 !important;
  }

.components-TravelerDetails-styles___addPaymentButtonContainer--dgV6e {
  margin-top: 24px;
}

.components-TravelerDetails-styles___addPaymentButton--BnxIo {
  width: 104px !important;
  min-width: 104px !important;
}

.components-TravelerDetails-styles___reimbursementContainer--vxK5a {
  margin-top: 24px;
  border-top: 1px solid rgba(224, 224, 224, 1);
  padding-top: 24px;
}

.components-TravelerDetails-styles___reimbursementContainer--vxK5a .components-TravelerDetails-styles___reimbursementText--jg8aO {
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
  }

.components-TravelerDetails-styles___reimbursementContainer--vxK5a .components-TravelerDetails-styles___reimbursementLoader--gwJrx {
    position: absolute;
  }

.components-TravelerDetails-styles___reimbursementContainer--vxK5a .components-TravelerDetails-styles___reimbursementLoader--gwJrx svg {
      margin-right: 0 !important;
    }

.components-TravelerDetails-styles___reimbursementContainer--vxK5a .components-TravelerDetails-styles___reimbursementLoader--gwJrx div:nth-of-type(2) {
      top: 0 !important;
      left: 30px !important;
    }

.components-TravelerDetails-styles___reimbursementContainer--vxK5a .components-TravelerDetails-styles___s-circular-progress--Wi1Et {
    position: absolute;
    top: 0;
    left: 30px;
  }

.components-TravelerDetails-styles___userIdContainer--ETK4v {
  display: flex;
  align-items: center;
  padding-top: 6px;
  justify-content: space-between;
}

.components-TravelerDetails-styles___copyButton--wZvxp {
  width: 44px;
  height: 44px;
  background-color: transparent;
  border: none;
  border-radius: 6px;
}

.components-TravelerDetails-styles___copyButton--wZvxp:hover {
  background-color: #0058ff;
}

.components-TravelerDetails-styles___userId--ip0IA {
  margin-right: 20px;
  font-size: 15px;
  font-family: 'Roboto';
}

.components-TravelerDetails-styles___expenseReports--IlPxL th {
    font-family: 'Roboto-Medium', 'Roboto' !important;
    font-weight: 500 !important;
    font-size: 15px;
    color: #1b2432;
  }

.components-TravelerDetails-styles___expenseReports--IlPxL .components-TravelerDetails-styles___tableRow--GO10g td:first-child {
      padding-left: 24px !important;
      min-width: 250px;
      max-width: 350px;
    }

.components-TravelerDetails-styles___expenseReports--IlPxL .components-TravelerDetails-styles___tableRow--GO10g td {
      font-family: 'Roboto-Regular', 'Roboto';
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
    }

.components-TravelerDetails-styles___expenseReports--IlPxL .components-TravelerDetails-styles___tableRow--GO10g td:last-child {
      padding-right: 20px !important;
    }

.components-TravelerDetails-styles___expenseReports--IlPxL .components-TravelerDetails-styles___tableRow--GO10g .components-TravelerDetails-styles___syncButton--bnTw_ {
      width: 61px;
      height: 32px;
      color: #318afb;
      border: 1px solid rgba(49, 138, 251, 0.5);
      border-radius: 4px;
    }

.components-TravelerDetails-styles___featureTableCell--y1HH8 {
  width: 100% !important;
}

.components-TravelerDetails-styles___settingTitle--Vwng2 {
  margin-bottom: 20px;
}

.components-TravelerDetails-styles___infoText--FGT6z {
  color: #6d717a;
  font-size: 13px;
  line-height: 20px;
}

.components-TravelerDetails-styles___infoText--FGT6z span {
    color: #1b2432;
  }

.components-TravelerDetails-styles___accountDetailsCont--IEzZG {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  border: 1px solid #edeeef;
  border-radius: 4px;
}

.components-TravelerDetails-styles___accountDetailsCont--IEzZG .components-TravelerDetails-styles___buttonContainer--dtFoz {
    margin-top: 24px;
    margin-right: 24px;
  }

.components-TravelerDetails-styles___accountDetailsContinerText--hLrTW {
  display: flex;
  flex-direction: column;
  padding-left: 24px;
  padding-top: 24px;
  width: 100%;
  padding-bottom: 24px;
}

.components-TravelerDetails-styles___flightCreditsHead--dXcT_ {
  text-align: left;
  padding-left: 15px !important;
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD {
  width: 100%;
}

.components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD table {
    table-layout: fixed;
    width: 100%;
  }

.components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD td,
  .components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD th {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

.components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD th {
    white-space: nowrap;
  }

/* Valid Until and Status columns */

.components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD td:nth-child(5),
  .components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD th:nth-child(5),
  .components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD td:nth-child(6),
  .components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD th:nth-child(6) {
    white-space: nowrap;
  }
`, "",{"version":3,"sources":["webpack://./components/TravelerDetails/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AA+BtB;;AA7BE;IACE,oBAAoB;EACtB;;AAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;EAWnB;;AATE;MACE,cAAc;MACd,eAAe;MACf,mBAAmB;IACrB;;AAEA;MACE,gBAAgB;IAClB;;AAIJ;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AACA;EACE,aAAa;EACb,gBAAgB;AAKlB;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAsBzB;;AAnBI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AACA;IACE,0BAA0B;EAC5B;;AAII;QACE,+CAA+C;MACjD;;AAKN;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;AAqF7B;;AAnFE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EA8Bd;;AA5BE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,wCAAwC;IAC1C;;AAEA;MACE,eAAe;MACf,iBAAiB;IAYnB;;AATE;QACE,eAAe;QACf,yBAAyB;QACzB,gBAAgB;MAClB;;AAEA;QACE,iBAAiB;MACnB;;AAIJ;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAEA;IACE,aAAa;IACb,sBAAsB;EAUxB;;AARE;MACE,uCAAuC;MACvC,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;IAClB;;AAGF;IACE,cAAc;EAChB;;AAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAKlB;;AAHE;MACE,4BAA4B;IAC9B;;AAIJ;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AAMf;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,gBAAgB;AAMlB;;AAJE;IACE,OAAO;IACP,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,eAAe;AAMjB;;AALE;IACE,cAAc;EAChB;;ACnVF;EDoVE,WAAW;EACX;CCrVF;;ADwVA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AAOf;;AALE;IACE,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;EACnB;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;AA4BjB;;AA1BE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,2BAA2B;EAoB7B;;AAlBE;;MAEE,gBAAgB;MAChB,2CAA2C;IAC7C;;AAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;AAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;IACtB;;AAIJ;EACE,gBAAgB;EAChB,uBAAuB;AAazB;;AAXI;MACE,yBAAyB;MACzB,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;MACf,eAAe;IACjB;;AAIJ;EACE,gBAAgB;EAChB,uBAAuB;AAYzB;;AAVI;MACE,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;MACf,eAAe;IACjB;;AAIJ;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AAyGxB;;AAvGE;;AAPF;IAQI;AAsGJ;EArGE;;AACA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EAwBjB;;AAvBE;;AAJF;MAKI;EAsBJ;IArBE;;AAEA;;AARF;MASI,YAAY;MACZ;EAiBJ;IAhBE;;ACxeJ;;ID0eI,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd;CC9eJ;;ADgfI;MACE,uCAAuC;MACvC,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,eAAe;IACjB;;AAEF;IACE,WAAW;EASb;;AARE;;AAFF;MAGI;EAOJ;IANE;;AAEA;;AANF;MAOI,YAAY;MACZ;EAEJ;IADE;;AAIA;MACE,gBAAgB;IAClB;;AACA;MACE,YAAY;IACd;;AAGF;IACE,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;AAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;AACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;AAEA;IACE,wBAAwB;EAC1B;;AAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;AAEA;IACE,kBAAkB;EACpB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;AAGF;EACE,aAAa;AAwEf;;AAtEE;IACE,OAAO;IACP,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAOlB;;AALE;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;;AAGF;IACE,iBAAiB;EAMnB;;AAJE;MACE,WAAW;MACX,YAAY;IACd;;AAGF;IACE,aAAa;IACb,qBAAqB;EAsCvB;;AApCE;MACE,kBAAkB;MAClB,eAAe;IAiBjB;;AAfE;QACE,WAAW;QACX,YAAY;MACd;;AAEA;QACE,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;MAC3B;;AAGF;MACE,qBAAqB;MACrB,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AACA;MACE,qBAAqB;MACrB,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAGF;IACE,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;EAClB;;AAGF;EACE,eAAe;EACf,gCAAgC;AAgFlC;;AA9EE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;AAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;AAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EA+BnB;;AA7BE;MACE,aAAa;IAef;;AAbE;QACE,eAAe;MACjB;;AACA;QACE,gBAAgB;MAClB;;AAEA;QACE,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,cAAc;MAChB;;AAGF;MACE,cAAc;MACd,iBAAiB;IACnB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,iBAAiB;IACnB;;AAGF;IACE,aAAa;IACb,mBAAmB;EAIrB;;AAHE;MACE,kBAAkB;IACpB;;AAIJ;EACE,aAAa;EACb,oBAAoB;AAgCtB;;AA9BE;IACE,kBAAkB;IAClB,eAAe;EAMjB;;AAJE;MACE,WAAW;MACX,YAAY;IACd;;AAGF;IACE,YAAY;IACZ,OAAO;EACT;;AAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAGE;IACE,uBAAuB;EACzB;;ACpxBF;EDqxBE;CCrxBF;;ADuxBE;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AA0B3B;;AAzBE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAY7B;;AAVE;IACE,eAAe;IACf,kBAAkB;EACpB;;AAEE;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;;AAIJ;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AAazB;;AAXI;MACE,yBAAyB;MACzB,oBAAoB;MACpB,YAAY;MACZ,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;MACf,eAAe;IACjB;;AAIJ;EACE,gBAAgB;EAChB,uBAAuB;AAYzB;;AAVI;MACE,oBAAoB;MACpB,YAAY;MACZ,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;MACf,eAAe;IACjB;;AAIJ;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAGE;IACE,qBAAqB;EACvB;;AACA;IACE,gBAAgB;EAClB;;AAGF;EACE,sBAAsB;EACtB,0BAA0B;AAM5B;;AAJE;IACE,oCAAoC;IACpC,cAAc;EAChB;;AAGF;EACE,8BAA8B;AAKhC;;AAHE;IACE,2CAA2C;EAC7C;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AAIf;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAGE;IACE,0BAA0B;EAC5B;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,iBAAiB;AAwBnB;;AAtBE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAEA;IACE,kBAAkB;EASpB;;AARE;MACE,0BAA0B;IAC5B;;AAEA;MACE,iBAAiB;MACjB,qBAAqB;IACvB;;AAEF;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;EACZ;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAGE;IACE,iDAAiD;IACjD,2BAA2B;IAC3B,eAAe;IACf,cAAc;EAChB;;AAEE;MACE,6BAA6B;MAC7B,gBAAgB;MAChB,gBAAgB;IAClB;;AACA;MACE,uCAAuC;MACvC,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAEA;MACE,8BAA8B;IAChC;;AAEA;MACE,WAAW;MACX,YAAY;MACZ,cAAc;MACd,yCAAyC;MACzC,kBAAkB;IACpB;;AAIJ;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AAKnB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AAMpB;;AAJE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AAyBb;;AAvBE;IACE,mBAAmB;IACnB,WAAW;EACb;;AAEA;;IAEE,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;AAEA;IACE,mBAAmB;EACrB;;AAEA,mCAAmC;;AACnC;;;;IAIE,mBAAmB;EACrB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 900px;\n  margin: 0 auto 30px;\n  margin-left: 0;\n}\n\n.paperAccount {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 auto 0 0;\n  width: 100%;\n  padding-left: 22px;\n  padding-right: 22px;\n}\n\n.paperAccountLoading {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 auto 0 0;\n  background-color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.dropdown {\n  padding: 15px;\n  max-width: 736px;\n}\n\n.root {\n  width: 100%;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n\n  &.inputContainerTravelerSelection {\n    padding: 16px 0 0;\n    border-bottom: none;\n    padding-top: 0;\n  }\n\n  &.inputContainerTravelerSelectionOpen {\n    padding: 0 0 32px 0;\n  }\n\n  &.wrapperContainer {\n    border-top: 1px solid #dddee0;\n    flex-direction: column;\n    padding-top: 32px;\n\n    .subtitle {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 6px 0 16px;\n    }\n\n    .radioGroupLabel {\n      font-weight: 400;\n    }\n  }\n}\n\n.secondarySelectInput {\n  display: flex;\n  align-items: center;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.inputInVisible {\n  display: none;\n}\n.inputWrapper_department {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n\n  div label {\n    z-index: 0;\n  }\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n  td:first-child {\n    padding-left: 0 !important;\n  }\n\n  &.paymentTableRow {\n    &:last-child {\n      .tableCell {\n        border-bottom: 1px solid rgba(224, 224, 224, 1);\n      }\n    }\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 15px 16px 15px !important;\n  min-width: unset !important;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .button_more {\n      min-width: 10px;\n    }\n\n    .button_more:hover {\n      background-color: transparent !important;\n    }\n\n    .menuList {\n      font-size: 15px;\n      letter-spacing: 0;\n\n\n      li:nth-child(3) {\n        font-size: 15px;\n        color: #fc3b60 !important;\n        font-weight: 600;\n      }\n\n      svg {\n        margin-right: 5px;\n      }\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n\n  .alertMessageCont {\n    display: flex;\n    flex-direction: column;\n\n    .alertMessage {\n      font-family: 'Roboto-Regular', 'Roboto';\n      font-size: 11px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-top: 4px;\n      font-weight: 400;\n    }\n  }\n\n  &.tableCellPayment {\n    color: #6d717a;\n  }\n\n  &.tableCellType {\n    font-weight: 600;\n    color: #1b2432;\n  }\n\n  .alertMessageContInside {\n    display: flex;\n    flex-direction: row;\n    margin-top: 17px;\n\n    svg {\n      margin-right: 5px !important;\n    }\n  }\n}\n\n.extraMargin {\n  padding-left: 36px !important;\n}\n\n.alertIcon {\n  width: 16px !important;\n  padding-right: 0 !important;\n  min-width: 16px !important;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n.phoneFields {\n  display: flex;\n\n  .countryCode {\n    margin-right: 6px;\n    max-width: 192px;\n  }\n}\n\n.buttons {\n  border-top: 1px solid #dddee0;\n  padding-top: 32px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.buttonDeactivateCont {\n  padding-top: 32px;\n  display: flex;\n  justify-content: flex-start;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.buttonDeactivate {\n  border: 1px solid #fc3b60 !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  min-width: 161px !important;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.buttonReactivate {\n  border: 1px solid #318afb !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  min-width: 161px !important;\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.cancel {\n  color: #6d717a;\n  margin-right: 12px;\n}\n\n.tabs,\n.tabbs,\n.tab,\n.tabb {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n}\n\n.tabb {\n  border-bottom: 1px solid #c6c8cc !important;\n  padding: 15px;\n}\n\n.loyalityTabs {\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    max-width: 170px;\n  }\n}\n\n.addProgram {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  padding: 18px 0 18px 0;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n  width: 100%;\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.close {\n  cursor: pointer;\n  display: none;\n\n  .icon {\n    color: rgba(0, 0, 0, 0.23);\n    font-size: 16px;\n    margin-right: 2px;\n  }\n}\n\n.loaderContainer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.sortBy {\n  position: absolute;\n  right: 0;\n  font-size: 15px;\n  height: 48px;\n  padding: 0 15px;\n\n  .select {\n    margin-left: 5px;\n    font-weight: 700;\n    font-size: 15px;\n    height: 48px !important;\n    min-height: 48px !important;\n\n    &:before,\n    &:after {\n      transition: none;\n      border-bottom-color: transparent !important;\n    }\n\n    > div {\n      display: flex;\n      align-items: center;\n    }\n\n    .icon {\n      width: 20px;\n      height: 20px;\n      margin-left: -24px;\n      margin-top: -3px;\n      pointer-events: none;\n    }\n  }\n}\n\n.selected {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    .iconStyle {\n      transform: rotate(180deg);\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n      margin-right: 0;\n    }\n  }\n}\n\n.select {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    .iconStyle {\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n      margin-right: 0;\n    }\n  }\n}\n\n.informationTitle {\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-family: 'Roboto-Medium', 'Roboto', sans-serif;\n}\n\n.addMarginTop {\n  margin-top: 32px;\n}\n\n.billingAddress {\n  font-size: 15px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: right;\n}\n\n.billingAddressContainer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rule {\n  margin-top: 30px;\n}\n\n.fraudRules {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  flex-direction: column;\n\n  @media only screen and (min-width: 1220px) {\n    flex-direction: row;\n  }\n  .fraud {\n    margin-top: 10px;\n    width: 100%;\n    margin-right: 0;\n    @media only screen and (min-width: 1220px) {\n      margin-right: 10px;\n    }\n\n    @media only screen and (min-width: 1300px) {\n      width: 270px;\n      max-width: 270px;\n    }\n\n    font-family: 'Roboto-Regular', 'Roboto';\n    font-weight: 500;\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n\n    .description {\n      font-family: 'Roboto-Regular', 'Roboto';\n      font-weight: 400;\n      font-size: 13px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin-top: 6px;\n    }\n  }\n  .fraudSelect {\n    width: 100%;\n    @media only screen and (min-width: 1220px) {\n      max-width: 300px;\n    }\n\n    @media only screen and (min-width: 1420px) {\n      width: 320px;\n      max-width: 320px;\n    }\n  }\n\n  .inputWrapper {\n    div {\n      min-width: 220px;\n    }\n    .marginNormal {\n      width: 220px;\n    }\n  }\n\n  .recommended {\n    background: rgba(18, 218, 159, 0.1);\n    border: 1px solid #12da9f;\n    border-radius: 4px;\n    width: 105px !important;\n    height: 24px;\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .recommendedItemContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  .tableCell:first-child {\n    padding-left: 0 !important;\n    padding-right: 63px !important;\n  }\n\n  .selectWrapper {\n    margin-top: 0 !important;\n  }\n\n  .editAnalyticsContainer {\n    display: flex;\n    justify-content: space-between;\n    width: 320px;\n    max-width: 320px;\n  }\n\n  .editAnalyticsContainer svg {\n    margin-right: 15px;\n  }\n\n  .editAnalyticsText {\n    font-weight: 700;\n  }\n\n  .editAnalytics {\n    cursor: pointer;\n    font-size: 15px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: right;\n  }\n}\n\n.header {\n  display: flex;\n\n  .title {\n    flex: 1;\n    font-size: 21px;\n    line-height: 24px;\n    font-weight: 500;\n\n    span {\n      font-size: 15px;\n      color: #6d717a;\n      font-weight: 400;\n    }\n  }\n\n  .tripAdvisor {\n    text-align: right;\n\n    img {\n      width: 95px;\n      height: auto;\n    }\n  }\n\n  .avatarAndName {\n    display: flex;\n    align-items: self-end;\n\n    .avatarContainer {\n      margin-right: 24px;\n      margin-top: 4px;\n\n      .avatar {\n        width: 32px;\n        height: 32px;\n      }\n\n      .avatarLetter {\n        width: 32px;\n        height: 32px;\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n        text-align: center;\n        background-color: #e0e2e6;\n        text-transform: uppercase;\n      }\n    }\n\n    .titleStyle {\n      font-family: 'Roboto';\n      font-weight: 500;\n      font-size: 21px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin-bottom: 7px;\n    }\n    .subtitleStyle {\n      font-family: 'Roboto';\n      font-weight: 400;\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n  }\n\n  .passengerInfo {\n    display: flex;\n    align-content: space-between;\n    justify-content: space-between;\n    max-width: 672px;\n  }\n}\n\n.userDetailsHeader {\n  padding: 32px 0;\n  border-bottom: 1px solid #c6c8cc;\n\n  &:last-child {\n    padding: 32px 0 0;\n    border-bottom: none;\n    padding-top: 20px;\n  }\n\n  .title {\n    margin-bottom: 24px;\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 500;\n  }\n\n  .userName {\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 500;\n    font-family: 'Roboto';\n  }\n\n  .userDetailsInfo {\n    max-width: 850px;\n    border: 1px solid #dddee0;\n    padding: 23px;\n    border-radius: 4px;\n  }\n\n  .Info {\n    display: flex;\n  }\n\n  .userInfoRow {\n    min-width: 280px;\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n    line-height: 20px;\n\n    .passportInfo {\n      display: flex;\n\n      p {\n        margin-top: 0px;\n      }\n      p:first-child {\n        margin-top: 13px;\n      }\n\n      .passList {\n        line-height: 7px;\n        margin-top: 6px;\n        margin-left: 5px;\n        color: #1b2432;\n      }\n    }\n\n    span {\n      color: #1b2432;\n      letter-spacing: 0;\n    }\n\n    .label {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n      line-height: 20px;\n    }\n  }\n\n  .userInfoRowWithIcon {\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 10px;\n    }\n  }\n}\n\n.iconAndInfoContainer {\n  display: flex;\n  align-items: stretch;\n\n  .iconContainer {\n    margin-right: 24px;\n    margin-top: 4px;\n\n    .icon {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .infoContainer {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .titleStyle {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 21px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin-bottom: 7px;\n  }\n  .subtitleStyle {\n    font-family: 'Roboto';\n    font-weight: 400;\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.userNameAndActionbuttonContaner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.noBorder {\n  fieldset {\n    border: none !important;\n  }\n  margin: 0 !important;\n\n  div {\n    padding: 0 !important;\n    padding-left: 1px !important;\n    font-size: 17px;\n    font-weight: 600;\n  }\n}\n\n.line {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.selectTraveler {\n  min-width: 118px;\n  font-size: 17px;\n}\n\n.avatarAndNameActionButton {\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n}\n\n.membershipDescription {\n  margin-top: 20px;\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.popupButtonsContainer {\n  border-top: 1px solid #e0e2e6;\n  padding-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n  button {\n    width: 150px;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.addNewTableRowProgram {\n  margin-top: 20px;\n}\n\n.profileInfo {\n  display: flex;\n  justify-content: flex-start;\n\n  p {\n    margin-top: 6px;\n    margin-bottom: 6px;\n  }\n  .passportInfo {\n    p {\n      margin-top: 6px !important;\n      margin-bottom: 6px;\n    }\n  }\n}\n\n.passportInfoLabel {\n  margin-top: 6px !important;\n}\n\n.selected {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    .iconStyleProfile {\n      transform: rotate(180deg);\n      top: calc(50% - 8px);\n      right: -20px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n      margin-right: 0;\n    }\n  }\n}\n\n.select {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    .iconStyleProfile {\n      top: calc(50% - 8px);\n      right: -20px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n      margin-right: 0;\n    }\n  }\n}\n\n.addProgramButtonLabel {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n\n.loyaltyProgramTable {\n  td {\n    font-family: 'Roboto';\n  }\n  td:first-child {\n    font-weight: 600;\n  }\n}\n\n.editButton {\n  width: 55px !important;\n  min-width: 55px !important;\n\n  &:hover {\n    background-color: #318afb !important;\n    color: #ffffff;\n  }\n}\n\n.loyalityTabs {\n  border-bottom: none !important;\n\n  button {\n    border-bottom: 1px solid #c6c8cc !important;\n  }\n}\n\n.passengerDesc {\n  color: #1b2432;\n}\n\n.balance {\n  width: 354px;\n  margin-right: 0;\n  margin-left: 30px !important;\n}\n\n.userIdPaper {\n  width: 354px;\n  margin-right: 0;\n  margin-top: 30px;\n  margin-left: 30px !important;\n}\n\n.AccountBalance {\n  display: flex;\n}\n\n.points {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-size: 21px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.rewardIconAndText {\n  margin-top: 22px;\n  display: flex;\n  svg {\n    margin-right: 18px;\n  }\n}\n\n.loyaltyProgramTable {\n  border-bottom: 1px solid rgba(224, 224, 224, 1);\n}\n\n.accountDetailsContiner {\n  display: flex;\n  flex-direction: row;\n}\n\n.firstToLeft {\n  td:first-child {\n    padding-left: 0 !important;\n  }\n}\n\n.addPaymentButtonContainer {\n  margin-top: 24px;\n}\n\n.addPaymentButton {\n  width: 104px !important;\n  min-width: 104px !important;\n}\n\n.reimbursementContainer {\n  margin-top: 24px;\n  border-top: 1px solid rgba(224, 224, 224, 1);\n  padding-top: 24px;\n\n  .reimbursementText {\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n\n  .reimbursementLoader {\n    position: absolute;\n    svg {\n      margin-right: 0 !important;\n    }\n\n    div:nth-of-type(2) {\n      top: 0 !important;\n      left: 30px !important;\n    }\n  }\n  .s-circular-progress {\n    position: absolute;\n    top: 0;\n    left: 30px;\n  }\n}\n\n.userIdContainer {\n  display: flex;\n  align-items: center;\n  padding-top: 6px;\n  justify-content: space-between;\n}\n\n.copyButton {\n  width: 44px;\n  height: 44px;\n  background-color: transparent;\n  border: none;\n  border-radius: 6px;\n}\n\n.copyButton:hover {\n  background-color: #0058ff;\n}\n\n.userId {\n  margin-right: 20px;\n  font-size: 15px;\n  font-family: 'Roboto';\n}\n\n.expenseReports {\n  th {\n    font-family: 'Roboto-Medium', 'Roboto' !important;\n    font-weight: 500 !important;\n    font-size: 15px;\n    color: #1b2432;\n  }\n  .tableRow {\n    td:first-child {\n      padding-left: 24px !important;\n      min-width: 250px;\n      max-width: 350px;\n    }\n    td {\n      font-family: 'Roboto-Regular', 'Roboto';\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n    }\n\n    td:last-child {\n      padding-right: 20px !important;\n    }\n\n    .syncButton {\n      width: 61px;\n      height: 32px;\n      color: #318afb;\n      border: 1px solid rgba(49, 138, 251, 0.5);\n      border-radius: 4px;\n    }\n  }\n}\n\n.featureTableCell {\n  width: 100% !important;\n}\n\n.settingTitle {\n  margin-bottom: 20px;\n}\n\n.infoText {\n  color: #6d717a;\n  font-size: 13px;\n  line-height: 20px;\n\n  span {\n    color: #1b2432;\n  }\n}\n\n.accountDetailsCont {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  border: 1px solid #edeeef;\n  border-radius: 4px;\n\n  .buttonContainer {\n    margin-top: 24px;\n    margin-right: 24px;\n  }\n}\n\n.accountDetailsContinerText {\n  display: flex;\n  flex-direction: column;\n  padding-left: 24px;\n  padding-top: 24px;\n  width: 100%;\n  padding-bottom: 24px;\n}\n\n.flightCreditsHead {\n  text-align: left;\n  padding-left: 15px !important;\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.flightCreditsTableWrapper {\n  width: 100%;\n\n  table {\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  td,\n  th {\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n  }\n\n  th {\n    white-space: nowrap;\n  }\n\n  /* Valid Until and Status columns */\n  td:nth-child(5),\n  th:nth-child(5),\n  td:nth-child(6),\n  th:nth-child(6) {\n    white-space: nowrap;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-TravelerDetails-styles___paper--YB3d8`,
	"paperAccount": `components-TravelerDetails-styles___paperAccount--Bu2i2`,
	"paperAccountLoading": `components-TravelerDetails-styles___paperAccountLoading--aGFAG`,
	"dropdown": `components-TravelerDetails-styles___dropdown--UV0_Q`,
	"root": `components-TravelerDetails-styles___root--iOl9o`,
	"menuItem": `components-TravelerDetails-styles___menuItem--rbSzl`,
	"listItem": `components-TravelerDetails-styles___listItem--q06ZW`,
	"location": `components-TravelerDetails-styles___location--rnkIH`,
	"inputContainer": `components-TravelerDetails-styles___inputContainer--gGQWb`,
	"passportInfo": `components-TravelerDetails-styles___passportInfo--ULSLg`,
	"inputContainerTravelerSelection": `components-TravelerDetails-styles___inputContainerTravelerSelection--IISEP`,
	"inputContainerTravelerSelectionOpen": `components-TravelerDetails-styles___inputContainerTravelerSelectionOpen--Bmq59`,
	"wrapperContainer": `components-TravelerDetails-styles___wrapperContainer--_LS6p`,
	"subtitle": `components-TravelerDetails-styles___subtitle--iniOk`,
	"radioGroupLabel": `components-TravelerDetails-styles___radioGroupLabel--XaceB`,
	"secondarySelectInput": `components-TravelerDetails-styles___secondarySelectInput--BJ5sY`,
	"inputWrapper": `components-TravelerDetails-styles___inputWrapper--BHow2`,
	"inputInVisible": `components-TravelerDetails-styles___inputInVisible--g4qhl`,
	"inputWrapperDepartment": `components-TravelerDetails-styles___inputWrapper_department--WDakw`,
	"table": `components-TravelerDetails-styles___table--iCPzv`,
	"tableHead": `components-TravelerDetails-styles___tableHead--HRwxl`,
	"tableRow": `components-TravelerDetails-styles___tableRow--GO10g`,
	"tableCell": `components-TravelerDetails-styles___tableCell--ju6P3`,
	"addNewTableRow": `components-TravelerDetails-styles___addNewTableRow--MNUIM`,
	"paymentTableRow": `components-TravelerDetails-styles___paymentTableRow--SKggx`,
	"removeCell": `components-TravelerDetails-styles___removeCell--LzP71`,
	"buttonMore": `components-TravelerDetails-styles___button_more--_U7FU`,
	"menuList": `components-TravelerDetails-styles___menuList--R_Dcw`,
	"inputTableCell": `components-TravelerDetails-styles___inputTableCell--I7fIl`,
	"buttonTableCell": `components-TravelerDetails-styles___buttonTableCell--SpQMv`,
	"alertMessageCont": `components-TravelerDetails-styles___alertMessageCont--mYpSr`,
	"alertMessage": `components-TravelerDetails-styles___alertMessage--P6W61`,
	"tableCellPayment": `components-TravelerDetails-styles___tableCellPayment--w6Mu7`,
	"tableCellType": `components-TravelerDetails-styles___tableCellType--AEYIJ`,
	"alertMessageContInside": `components-TravelerDetails-styles___alertMessageContInside--pIiMU`,
	"extraMargin": `components-TravelerDetails-styles___extraMargin--BbW24`,
	"alertIcon": `components-TravelerDetails-styles___alertIcon--jpv4l`,
	"emptyData": `components-TravelerDetails-styles___emptyData--dlG9h`,
	"selectWrapper": `components-TravelerDetails-styles___selectWrapper--TZVDi`,
	"phoneFields": `components-TravelerDetails-styles___phoneFields--P3u4k`,
	"countryCode": `components-TravelerDetails-styles___countryCode--Fdjfa`,
	"buttons": `components-TravelerDetails-styles___buttons--KzdUu`,
	"buttonDeactivateCont": `components-TravelerDetails-styles___buttonDeactivateCont--e8W1O`,
	"buttonDeactivate": `components-TravelerDetails-styles___buttonDeactivate--ntVGz`,
	"buttonReactivate": `components-TravelerDetails-styles___buttonReactivate--BoTtP`,
	"cancel": `components-TravelerDetails-styles___cancel--tgzXk`,
	"tabs": `components-TravelerDetails-styles___tabs--VyIQ6`,
	"tabbs": `components-TravelerDetails-styles___tabbs--OAbTJ`,
	"tab": `components-TravelerDetails-styles___tab--kEhXd`,
	"tabb": `components-TravelerDetails-styles___tabb--ppwu8`,
	"loyalityTabs": `components-TravelerDetails-styles___loyalityTabs--VXZzj`,
	"addProgram": `components-TravelerDetails-styles___addProgram--CBaJ2`,
	"addIcon": `components-TravelerDetails-styles___addIcon--vxsDN`,
	"close": `components-TravelerDetails-styles___close--C2E3k`,
	"icon": `components-TravelerDetails-styles___icon--iyYSg`,
	"loaderContainer": `components-TravelerDetails-styles___loaderContainer--xQvgA`,
	"sortBy": `components-TravelerDetails-styles___sortBy--Ri3ZK`,
	"select": `components-TravelerDetails-styles___select--ujRkv`,
	"selected": `components-TravelerDetails-styles___selected--UkJCB`,
	"iconStyle": `components-TravelerDetails-styles___iconStyle--nuYJf`,
	"informationTitle": `components-TravelerDetails-styles___informationTitle--YNijO`,
	"addMarginTop": `components-TravelerDetails-styles___addMarginTop--SH3HM`,
	"billingAddress": `components-TravelerDetails-styles___billingAddress--_L0aG`,
	"billingAddressContainer": `components-TravelerDetails-styles___billingAddressContainer--uBbq7`,
	"rule": `components-TravelerDetails-styles___rule--CpREB`,
	"fraudRules": `components-TravelerDetails-styles___fraudRules--MF5Ma`,
	"fraud": `components-TravelerDetails-styles___fraud--atVjN`,
	"description": `components-TravelerDetails-styles___description--ga9FB`,
	"fraudSelect": `components-TravelerDetails-styles___fraudSelect--ufQz1`,
	"marginNormal": `components-TravelerDetails-styles___marginNormal--MRC8y`,
	"recommended": `components-TravelerDetails-styles___recommended--iOZGn`,
	"recommendedItemContainer": `components-TravelerDetails-styles___recommendedItemContainer--X7lxR`,
	"editAnalyticsContainer": `components-TravelerDetails-styles___editAnalyticsContainer--bWRTC`,
	"editAnalyticsText": `components-TravelerDetails-styles___editAnalyticsText--OpSGR`,
	"editAnalytics": `components-TravelerDetails-styles___editAnalytics--MaBT2`,
	"header": `components-TravelerDetails-styles___header--epoL8`,
	"title": `components-TravelerDetails-styles___title--sc9Cy`,
	"tripAdvisor": `components-TravelerDetails-styles___tripAdvisor--lhkrD`,
	"avatarAndName": `components-TravelerDetails-styles___avatarAndName--ueu81`,
	"avatarContainer": `components-TravelerDetails-styles___avatarContainer--maUSH`,
	"avatar": `components-TravelerDetails-styles___avatar--hwZ5k`,
	"avatarLetter": `components-TravelerDetails-styles___avatarLetter--SS64K`,
	"titleStyle": `components-TravelerDetails-styles___titleStyle--Q070x`,
	"subtitleStyle": `components-TravelerDetails-styles___subtitleStyle--yQV43`,
	"passengerInfo": `components-TravelerDetails-styles___passengerInfo--d0VCq`,
	"userDetailsHeader": `components-TravelerDetails-styles___userDetailsHeader--i3ddw`,
	"userName": `components-TravelerDetails-styles___userName--d4zNt`,
	"userDetailsInfo": `components-TravelerDetails-styles___userDetailsInfo--Agwab`,
	"info": `components-TravelerDetails-styles___Info--mLi4F`,
	"userInfoRow": `components-TravelerDetails-styles___userInfoRow--nW6cY`,
	"passList": `components-TravelerDetails-styles___passList--KS1AD`,
	"label": `components-TravelerDetails-styles___label--oIbRZ`,
	"userInfoRowWithIcon": `components-TravelerDetails-styles___userInfoRowWithIcon--iPtyz`,
	"iconAndInfoContainer": `components-TravelerDetails-styles___iconAndInfoContainer--wZbQd`,
	"iconContainer": `components-TravelerDetails-styles___iconContainer--QA7uP`,
	"infoContainer": `components-TravelerDetails-styles___infoContainer--ndcXT`,
	"buttonContainer": `components-TravelerDetails-styles___buttonContainer--dtFoz`,
	"userNameAndActionbuttonContaner": `components-TravelerDetails-styles___userNameAndActionbuttonContaner--kilSl`,
	"noBorder": `components-TravelerDetails-styles___noBorder--y2318`,
	"line": `components-TravelerDetails-styles___line--TtFFZ`,
	"selectTraveler": `components-TravelerDetails-styles___selectTraveler--OfgJ5`,
	"avatarAndNameActionButton": `components-TravelerDetails-styles___avatarAndNameActionButton--oipRU`,
	"membershipDescription": `components-TravelerDetails-styles___membershipDescription--RlzKC`,
	"popupButtonsContainer": `components-TravelerDetails-styles___popupButtonsContainer--iSrXY`,
	"cancelButton": `components-TravelerDetails-styles___cancelButton--hnmYV`,
	"addNewTableRowProgram": `components-TravelerDetails-styles___addNewTableRowProgram--D3V2x`,
	"profileInfo": `components-TravelerDetails-styles___profileInfo--I5XzE`,
	"passportInfoLabel": `components-TravelerDetails-styles___passportInfoLabel--FU1N1`,
	"iconStyleProfile": `components-TravelerDetails-styles___iconStyleProfile--JuOuW`,
	"addProgramButtonLabel": `components-TravelerDetails-styles___addProgramButtonLabel--Km8fT`,
	"loyaltyProgramTable": `components-TravelerDetails-styles___loyaltyProgramTable--G9v4X`,
	"editButton": `components-TravelerDetails-styles___editButton--Hbc6a`,
	"passengerDesc": `components-TravelerDetails-styles___passengerDesc--fttXu`,
	"balance": `components-TravelerDetails-styles___balance--znijq`,
	"userIdPaper": `components-TravelerDetails-styles___userIdPaper--lU1A3`,
	"accountBalance": `components-TravelerDetails-styles___AccountBalance--bkEeF`,
	"points": `components-TravelerDetails-styles___points--lop85`,
	"rewardIconAndText": `components-TravelerDetails-styles___rewardIconAndText--Qhmsm`,
	"accountDetailsContiner": `components-TravelerDetails-styles___accountDetailsContiner--UE6FS`,
	"firstToLeft": `components-TravelerDetails-styles___firstToLeft--S1ndV`,
	"addPaymentButtonContainer": `components-TravelerDetails-styles___addPaymentButtonContainer--dgV6e`,
	"addPaymentButton": `components-TravelerDetails-styles___addPaymentButton--BnxIo`,
	"reimbursementContainer": `components-TravelerDetails-styles___reimbursementContainer--vxK5a`,
	"reimbursementText": `components-TravelerDetails-styles___reimbursementText--jg8aO`,
	"reimbursementLoader": `components-TravelerDetails-styles___reimbursementLoader--gwJrx`,
	"sCircularProgress": `components-TravelerDetails-styles___s-circular-progress--Wi1Et`,
	"userIdContainer": `components-TravelerDetails-styles___userIdContainer--ETK4v`,
	"copyButton": `components-TravelerDetails-styles___copyButton--wZvxp`,
	"userId": `components-TravelerDetails-styles___userId--ip0IA`,
	"expenseReports": `components-TravelerDetails-styles___expenseReports--IlPxL`,
	"syncButton": `components-TravelerDetails-styles___syncButton--bnTw_`,
	"featureTableCell": `components-TravelerDetails-styles___featureTableCell--y1HH8`,
	"settingTitle": `components-TravelerDetails-styles___settingTitle--Vwng2`,
	"infoText": `components-TravelerDetails-styles___infoText--FGT6z`,
	"accountDetailsCont": `components-TravelerDetails-styles___accountDetailsCont--IEzZG`,
	"accountDetailsContinerText": `components-TravelerDetails-styles___accountDetailsContinerText--hLrTW`,
	"flightCreditsHead": `components-TravelerDetails-styles___flightCreditsHead--dXcT_`,
	"flightCreditsTableWrapper": `components-TravelerDetails-styles___flightCreditsTableWrapper--HEASD`
};
module.exports = ___CSS_LOADER_EXPORT___;
